import { z } from 'zod';
import { defineEndpoint } from '../define';

/**
 * Dispatch the register-ios-devices workflow in the mobile product's repo with
 * every stored UDID (Apple-side registration is idempotent), then mark the
 * previously-unregistered rows as registered by the caller. Requires
 * `releases:udids:manage`.
 */
export const registerAppleUdids = defineEndpoint({
  method: 'POST',
  path: '/v1/apple-udids/register',
  params: z.object({}),
  query: z.object({}),
  body: z.object({}).strict(),
  response: z.object({
    data: z.object({
      /** Rows newly marked registered by this dispatch. */
      dispatched: z.number(),
      /** Total UDIDs sent to the workflow. */
      total: z.number(),
    }),
  }),
});
